import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import { Server } from '../types';

interface ServerDropdownProps {
  value: string;
  onChange: (serverId: string) => void;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const ServerDropdown: React.FC<ServerDropdownProps> = ({
  value,
  onChange,
  className = '',
  required = false,
  disabled = false,
  placeholder = 'Select a server...'
}) => {
  const [servers, setServers] = useState<Server[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchServers();
  }, []);

  const fetchServers = async () => {
    try {
      setLoading(true);
      const response = await apiService.getAllServers();
      // Only show active servers in the dropdown
      setServers(response.filter((server: Server) => server.is_active));
      setError(null);
    } catch (err) {
      setError('Failed to fetch servers');
      console.error('Error fetching servers:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <select 
        className={`form-select ${className}`} 
        disabled
      >
        <option>Loading servers...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select 
        className={`form-select ${className}`} 
        disabled
      >
        <option>Error loading servers</option>
      </select>
    );
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`form-select ${className}`}
      required={required}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {servers.map(server => (
        <option key={server.id} value={server.id}>
          {server.name} ({server.host})
        </option>
      ))}
    </select>
  );
};

export default ServerDropdown;